module.exports = __webpack_public_path__ + "static/juniorDev-68f590dffeee6b0a206ad824f4ffbd7f.png";